import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../editorconfig';
import { UploadService } from '../../services/upload/upload.service';
import { DmsFile } from '../../modal/upload/model/upload.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-idex-commercial-rfp',
  standalone: false,
  templateUrl: './idex-commercial-rfp.component.html',
  styleUrl: './idex-commercial-rfp.component.scss'
})
export class IdexCommercialRfpComponent implements OnInit, AfterViewInit {
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @Input() id: any;
  @Input() schemeType: any;
  @Input() getUrl: string;
  @Input() postUrl: string;
  @Output() stepCompleted = new EventEmitter<void>();
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  // @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Output() submitProposal: EventEmitter<any> = new EventEmitter();
  private subscriptions = new Subscription();
  aip: FormGroup;
  apiUrl = environment.APIUrl;
  selectedProduct: any
  payload: any;
  uploadedFiles: any[] = [];
  allDmsFiles: any[] = [];
  aipId: any;
  aipData: any;
  uploadedDocs: any;
  rfpID: any
  @Input() step: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Output() generatePDFEmitter: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Input() proposalName: any;
  RFPForm: FormGroup;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  userID: any;
  uploadedUrl: null;
  tenderModes = [
    { label: 'Open Tender', value: 'Open Tender' },
    { label: 'Single Tender', value: 'Single Tender' },
    { label: 'Limited Tender', value: 'Limited Tender' },
  ];
  constructor(
    private fb: FormBuilder,
    // private config: PrimeNGConfig,
    private messageService: MessageService,
    private api: ApiService,
    private uploadService: UploadService,
    private route: ActivatedRoute
  ) {
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName
      }
      //console.log(this.payload);
    });
    this.RFPForm = this.fb.group({
      comment: [''],
      upload_rfp_date: [''],
      // tender_mode: [''],
      has_pre_bid: [false],
      pre_bid_date: [''],
      pre_bid_venue: [''],
      pre_bid_time: [''],
      bid_submission_date: [''],
      tendor_opening_date: [''],
      tendor_opening_time: [''],

      tendor_opening_venue: [''],
      mode_tendor: [''],
    });
    this.getRFPdata()
  }
  toggleSection(section: string) {
    this.expandedSections[section] = !this.expandedSections[section];
  }
  expandedSections: { [key: string]: boolean } =
    {
      basicInfo: false,
      MeetingDetails: false,
      Timeline: false,
      detailedInfo: false,
      uploads: false,
      vendorTable: false
    };

  ngAfterViewInit() {
    setTimeout(() => {
      // this.isEditorDisabled=true;
      if (this.stepDetails?.can_edit) {
        this.isEditorDisabled = false;
        this.RFPForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.RFPForm.disable();
      }
      // this.rebuildEditor()
    }, 3000);
  }
  editorReady = false;
  rebuildEditor() {
    this.editorReady = false; // destroy
    setTimeout(() => {
      this.init = this.getTinyInit(); // refresh config
      this.editorReady = true; // recreate editor
    }, 0);
  }
  getTinyInit(): EditorComponent['init'] {
    return {
      readonly: this.isEditorDisabled
    };
  }
  goToNextStep() {
    this.stepCompleted.emit();
  }
  onPdsTitleChange(event: any) { }
  generatePDF() {
    const payload = {
      url: '/revenue/need/version-control/',
      data: [
        { key: "Proposal Name", value: this.proposalName },
        { key: "RFP Details", value: this.RFPForm.get('comment')?.value },
      ]
    };

    this.generatePDFEmitter.emit(payload);
  }
  editForm() {
    this.RFPForm.enable();
    this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Form is now editable' });
  }

  onuploadChallengeSubmit() { }
  onRFPSubmit() {
    if (this.RFPForm.valid) {
      const formData = new FormData();
      formData.append('proposal_step', this.step.id);
      formData.append('comment', this.RFPForm.get('comment')?.value || '');
      formData.append('rfp_issue_date', this.RFPForm.get('upload_rfp_date')?.value || '');
      formData.append('pre_bid_date', this.RFPForm.get('pre_bid_date')?.value || '');
      formData.append('pre_bid_status', this.RFPForm.get('has_pre_bid')?.value || '');
      formData.append('venue', this.RFPForm.get('pre_bid_venue')?.value || '');
      formData.append('pre_bid_time', this.RFPForm.get('pre_bid_time')?.value || '');
      formData.append('bid_submission_date', this.RFPForm.get('bid_submission_date')?.value || '');
      formData.append('tendor_opening_date', this.RFPForm.get('tendor_opening_date')?.value || '');
      formData.append('tendor_opening_time', this.RFPForm.get('tendor_opening_time')?.value || '');
      formData.append('tendor_opening_venue', this.RFPForm.get('tendor_opening_venue')?.value || '');
      formData.append('mode_tendor', this.RFPForm.get('mode_tendor')?.value || '');

      if (this.rfpID) {
        let url = ['tdf', 'rev', 'makeII', 'makeI', 'makeIII'].includes(this.schemeType) ? `/revenue/issuance/rfp/${this.rfpID}/` : `/revenue/draft-rfp/${this.rfpID}/`
        this.api.putAPI(url, formData).subscribe((res: any) => {
          if (res) {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Data saved sucessfully'
            });
            this.fileUpload.clear()
            this.getRFPdata()
          }
        });
      }
      else {
        let url = ['tdf', 'rev', 'makeII', 'makeI', 'makeIII'].includes(this.schemeType) ? `/revenue/issuance/rfp/` : `/revenue/draft-rfp/`
        this.api.postAPI(url, formData).subscribe((res: any) => {
          if (res) {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Data saved successfully'
            });
            // this.fileUpload.clear()
            this.getRFPdata()
          }
        });
      }

    }
  }
  getRFPdata() {
    // let url =['tdf','rev','makeII'].includes(this.schemeType) ? `/revenue/issuance/rfp/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}` : `/revenue/draft-rfp/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`
    let url = ['tdf', 'rev', 'makeII', 'makeI', 'makeIII'].includes(this.schemeType) ? `/revenue/issuance/rfp/?proposal_step=${this.stepDetails.id}&proposal_step__proposal=${this.payload.proposal_id}` : `/revenue/draft-rfp/?proposal_step=${this.stepDetails.id}&proposal_step__proposal=${this.payload.proposal_id}`
    this.api.getAPI(url).subscribe({
      next: (res: any) => {
        console.log('this is revenue & TDF', res);
        this.rfpID = res[0]?.id || res?.data[0]?.id || null;
        this.uploadedUrl = res[0]?.file || res?.data[0]?.file || null;
        this.RFPForm.patchValue({
          comment: res[0]?.comment || res?.data[0]?.comment || '',
          upload_rfp_date: res[0]?.rfp_issue_date || res?.data[0]?.rfp_issue_date || '',
          pre_bid_date: res[0]?.pre_bid_date || res?.data[0]?.pre_bid_date || '',
          pre_bid_venue: res[0]?.venue || res?.data[0]?.venue || '',
          pre_bid_time: res[0]?.pre_bid_time || res?.data[0]?.pre_bid_time || '',
          // tender_mode: res[0].mode_tendor,
          bid_submission_date: res[0]?.bid_submission_date || res?.data[0]?.bid_submission_date || '',
          tendor_opening_date: res[0]?.tendor_opening_date || res?.data[0]?.tendor_opening_date || '',
          tendor_opening_time: res[0]?.tendor_opening_time || res?.data[0]?.tendor_opening_time || '',
          tendor_opening_venue: res[0]?.tendor_opening_venue || res?.data[0]?.tendor_opening_venue || '',
          pre_bid_status: res[0]?.pre_bid_status || res?.data[0]?.pre_bid_status || false,
          mode_tendor: res[0]?.mode_tendor || res?.data[0]?.mode_tendor || res.mode_tendor || '', 
          has_pre_bid: res[0]?.pre_bid_status || res?.data[0]?.pre_bid_status || false,
        });
        this.RFPForm.disable();
      },
      error: (err) => { }
    })
  }


}
